import { PRODUCTS } from "../data/products";

const ADMIN_TOKEN = "pirogi-admin-20021987";
const authHeaders = () => ({
  "Content-Type": "application/json",
  "X-Admin-Token": ADMIN_TOKEN,
});

const send = async (method, path, payload) => {
  const res = await fetch(`/api${path}`, {
    method,
    headers: authHeaders(),
    body: payload === undefined ? undefined : JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`${method} ${path} → ${res.status}`);
  return { data: await res.json() };
};

export const api = {
  get: async (path) => {
    if (path === "/products") {
      try {
        const res = await fetch("/api/products");
        if (!res.ok) throw new Error(String(res.status));
        return { data: await res.json() };
      } catch {
        return { data: PRODUCTS }; // фолбэк для пререндера/оффлайна
      }
    }
    throw new Error(`GET ${path} not available`);
  },
  post: async (path, payload) => {
    if (path === "/orders") {
      const order = {
        id: String(Date.now()),
        ...payload,
        created_at: new Date().toISOString(),
        status: "new",
      };
      const res = await fetch("/api/orders", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(order),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        throw new Error(data?.error || "Не удалось отправить заявку");
      }
      return { data: data?.order || order };
    }
    return send("POST", path, payload);
  },
  put: async (path, payload) => send("PUT", path, payload),
  delete: async (path) => send("DELETE", path),
};

export const buildImageUrl = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) {
    const match = urlOrPath.match(/\/assets\/images\/webp\/(.+?)$/);
    if (match) {
      return `/images/webp/${match[1]}`;
    }
    return urlOrPath;
  }
  return urlOrPath;
};
